import React, { type ReactNode, useMemo } from 'react';
import type { CustomFeature } from '@types';
import CustomFeatureContext from './CustomFeatureContext';
import type { CFSetData } from './typeHelpers';

interface Props {
  setData: CFSetData<CustomFeature>;
  data: CustomFeature;
  children: ReactNode;
}

function CustomFeatureProvider({ data, setData, children }: Props) {
  const value = useMemo(() => ({ data, setData }), [data, setData]);
  return (
    <CustomFeatureContext.Provider value={value}>
      {children}
    </CustomFeatureContext.Provider>
  );
}

export default CustomFeatureProvider;
